import React from 'react'
import Button from '../Button/Button';

import './IconButton.css'

const IconButton = ({children, tabIndex=0, disabled=false, className, onClick, icon}) => {

  return (
    <div className={"IconButton " + (className ? className : "")}>
      <Button onClick={onClick} tabIndex={tabIndex} disabled={disabled}>
        <img src={icon} />
        <span>{children}</span>
      </Button>
    </div>
  );
};

export default IconButton;
